import { Controller } from "@hotwired/stimulus"

// A tag box for picking up to five games.
//
// The chips are the interface; the form still posts one plain comma-separated
// field, so the server side stays a split() and nothing depends on this
// controller having run.
export default class extends Controller {
    static targets = ["chips", "input", "names"]
    static values = { max: Number, fullLabel: String }

    connect() {
        this.games = []
        this.render()
    }

    // Enter and comma commit; backspace on an empty box takes the last one back.
    key(event) {
        if (event.key === "Enter" || event.key === ",") {
            event.preventDefault()
            this.add()
        } else if (event.key === "Backspace" && this.inputTarget.value === "") {
            this.games.pop()
            this.render()
        }
    }

    // Picking from the datalist fires input with the full value and no keypress,
    // which is the one case where committing on input is right.
    pick(event) {
        if (event.inputType === undefined) this.add()
    }

    add() {
        const name = this.inputTarget.value.trim().replace(/,+$/, "")
        if (!name || this.full) return
        if (!this.games.some((game) => game.toLowerCase() === name.toLowerCase())) {
            this.games.push(name)
        }

        this.inputTarget.value = ""
        this.render()
    }

    remove(event) {
        this.games.splice(Number(event.params.index), 1)
        this.render()
        this.inputTarget.focus()
    }

    clear(event) {
        if (event.detail?.success === false) return

        this.games = []
        this.inputTarget.value = ""
        this.element.querySelectorAll("input[name=note]").forEach((field) => (field.value = ""))
        this.render()
    }

    get full() {
        return this.games.length >= this.maxValue
    }

    render() {
        this.chipsTarget.replaceChildren(...this.games.map((game, index) => this.chip(game, index)))
        this.namesTarget.value = this.games.join(",")

        this.inputTarget.disabled = this.full
        this.inputTarget.placeholder = this.full ? this.fullLabelValue : this.inputTarget.placeholder
    }

    chip(game, index) {
        const chip = document.createElement("span")
        chip.className = "game-chip"

        const name = document.createElement("span")
        name.className = "game-chip__name"
        name.textContent = game
        chip.append(name)

        const remove = document.createElement("button")
        remove.type = "button"
        remove.className = "game-chip__remove"
        remove.innerHTML = "<i class='fal fa-xmark'></i>"
        remove.dataset.action = "game-tags#remove"
        remove.dataset.gameTagsIndexParam = index
        chip.append(remove)

        return chip
    }
}
